import { getActiveMerchantId } from '@/utils/axios.utils';
import type {
  ModelUserResponse,
  UserServiceApiUserServiceCreateRequest,
  UserServiceApiUserServiceUpdateRequest,
} from '@layup/api-sdk';
import { userServiceClient } from './auth';
import { createLayupClient } from './layupApi';

export const getUsersByMerchant = async (): Promise<ModelUserResponse[]> => {
  const response = await userServiceClient().userServiceGetMany();
  return response.data.users as ModelUserResponse[];
};

export const updateUser = async (params: UserServiceApiUserServiceUpdateRequest): Promise<ModelUserResponse> => {
  const config = getActiveMerchantId();
  const response = await userServiceClient().userServiceUpdate(params, config);
  return response.data;
};

export const addMerchantUser = async (params: UserServiceApiUserServiceCreateRequest) => {
  const response = await userServiceClient().userServiceCreate(params);
  return response.data;
};

// I want to test this using raw axios instead of the sdk client, as the endpoint is working on the old ui
// but the sdk client is not working on the new ui while I'm passing the same exact params.
// I want to test if the issue is with the sdk client or there's something not configured correctly on the new ui/sdk
export const updateUserRaw = async (userId: string, payload: Record<string, any>): Promise<ModelUserResponse> => {
  const client = createLayupClient();
  const response = await client.put(`v1/users/${userId}`, payload);
  return response.data;
};
